<template>
  <div class="pdp-download" v-if="placementPdpCanBeDownloaded" :class="{ 'draft': !placementIsFinalised }">
    <div class="row">
      <div class="col-md d-flex align-items-center">
        <p v-if="placementIsFinalised">Download completed Performance and Development Plan.</p>
        <p v-else>Download draft Performance and Development Plan.</p>
      </div>
      <div class="col-md-auto d-flex align-items-center">
        <ladda-button class="btn btn-light" :click="download">
          <font-awesome :icon="['far', 'cloud-download']"/>
          <template v-if="placementIsFinalised"> Download PDF</template>
          <template v-else> Draft PDF</template>
        </ladda-button>
      </div>
    </div><!-- /.row -->
  </div><!-- /.pdp-download -->
</template>

<script>
import { placementComputed, placementMethods, graduateComputed } from 'vx/helpers'
import { helpers } from 'mixins/placements'
import { kebabCase } from 'lodash'

export default {
  mixins: [helpers],

  computed: {
    ...placementComputed,
    ...graduateComputed,

    placementPdpCanBeDownloaded () {
      return this.placementIsFinalised ||
        this.placementStartComponentIsPendingReview ||
        this.placementStartComponentIsSignedOff
    }
  },

  methods: {
    ...placementMethods,

    async download () {
      const response = await this.getPlacementPdp({
        placement: this.placement,
        graduate: this.graduate
      })

      let suffix = this.placementIsFinalised
        ? '-and-review'
        : ''

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(response.data, `${kebabCase(this.graduate.name)}-placement-${this.placement.number}-performance-and-development-plan${suffix}.pdf`)
      } else {
        let anchor = document.createElement('a')

        anchor.href = window.URL.createObjectURL(new Blob([response.data]))
        anchor.setAttribute(
          'download',
          `${kebabCase(this.graduate.name)}-placement-${this.placement.number}-performance-and-development-plan${suffix}.pdf`
        )

        document.body.appendChild(anchor)

        anchor.click()
        anchor.remove()
      }
    }
  }
}
</script>
